<!-- Full screen absolute -->
<div fxLayout="column" fxLayoutAlign="center center"
     fxLayoutGap="10px" class="popup-loader background-popup-loader white-spinner" *ngIf="flagLoading"
  [class.transparent]="transparent">

   <div class="flex flex-col items-center">
     <img src="/assets/img/spinner.gif" class="h-24">
   </div>

   <div fxLayoutAlign="center center" class="text-center" *ngIf="!transparent">
       <div *ngIf="statusMessageInner"  class="mat-subheading-1" class="loader-message"[innerHTML]="statusMessageInner | translate"> </div>
       <span  *ngIf="!statusMessageInner" class="mat-subheading-1" class="loader-message">{{statusMessage}}</span>
   </div>

</div>
